import { ReactElement, useCallback } from 'react';

import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../../translations';
import { DraftPrescriptionField } from '../../DraftPrescriptionsForm.types';

type MedicineParametersChangedModalProps = {
   readonly children: ReactElement;
   readonly draftPrescriptions: DraftPrescriptionField[];
};

export const MedicineParametersChangedShowModalEventInterceptor = (
   props: MedicineParametersChangedModalProps
): ReactElement => {
   const shouldShowModal = useCallback(
      () =>
         props.draftPrescriptions.some(
            (prescription) =>
               'patientMedicine' in prescription.selectedByUser &&
               prescription.selectedByUser.patientMedicine?.previouslyUsedMedicineId
         ),
      [props.draftPrescriptions]
   );

   return (
      <ShowModalEventInterceptor
         testId={'confirmPrescriptionWithMedicineParametersChanged'}
         confirmationButtonLabel={draftPrescriptionsTranslationKeys.confirmChangesAndSend}
         title={draftPrescriptionsTranslationKeys.medicineParametersChanged}
         modalWidth={ModalWidth.NORMAL}
         content={draftPrescriptionsTranslationKeys.yourIssuingPrescriptionWithMedicineParametersChanged}
         shouldShowModal={shouldShowModal}
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
